module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-1.0981529.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-1.jpg
// module id = p42B
// module chunks = 1